<template>
  <div>
    <h1>test theme9</h1>
    <div id="about_page" class="hero-area">
        <div class="container">
            <div class="row hero-area-inner">
                <div class="col-xl-9 col-lg-9">
                    <div class="hero-area-content">
                        <div class="section-title">                            
                            <h1>Learn About Our <br></h1>
                            <h1 class="pl-150">Vision and Values</h1>
                        </div>
                    </div>
                </div> 
                <div class="col-xl-3 col-lg-3 d-none d-lg-block text-lg-end">
                    <h4>Our History</h4>
                </div>                   
            </div>        
            <div class="row">
                <div class="about-feature-img">
                    <!--<img src="public/theme9/img/about/about-feature-img.jpg" alt="">-->
                </div>
            </div>   
            <div class="row mt-30">                
                <p>Architon was founded in 1995 in California, USA. The company was established by Louis Skidmore and Nathaniel Owings, and later joined by John O. Merrill.</p>
                <p>The company has designed the John Hancock Center, One World Trade Center and Burj Khalifa, which is currently the tallest building in the world. Throughout its history, Architon has been recognized for its innovative designs and commitment to sustainability.</p>
                <p> </p>
            </div>          
        </div>                
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme9Test',
  mixins: [ComponentMixin],
});
</script>
